const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const getToken = () => localStorage.getItem("token");

const api = async (method, path, body = null) => {
  const headers = { "Content-Type": "application/json" };
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : null,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Request failed");
  }

  return res.json();
};

export const apiGet = (path) => api("GET", path);
export const apiPost = (path, body) => api("POST", path, body);
export const apiPatch = (path, body) => api("PATCH", path, body);
export const apiDelete = (path) => api("DELETE", path);

export const apiPostFormData = async (path, formData) => {
  const headers = {};
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    headers,
    body: formData,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Request failed");
  }
  return res.json();
};

export default api;